// Emitted in place of a Slack search/read result when the user hasn't granted
// the per-user Slack token (or granted it without a needed scope).
export interface ConnectSlackPayload {
  type: "connect_slack";
  provider: string;
  reason: "not_connected" | "missing_scope";
  missingScopes?: string[];
}

const REASONS: ReadonlySet<ConnectSlackPayload["reason"]> = new Set(["not_connected", "missing_scope"]);

const isReason = (v: unknown): v is ConnectSlackPayload["reason"] =>
  typeof v === "string" && REASONS.has(v as ConnectSlackPayload["reason"]);

// Tolerates unknown reasons so a newer backend still renders the card.
export const parseConnectSlackPayload = (v: unknown): ConnectSlackPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "connect_slack") return null;
  if (typeof r.provider !== "string") return null;
  return {
    type: "connect_slack",
    provider: r.provider,
    reason: isReason(r.reason) ? r.reason : "not_connected",
    ...(Array.isArray(r.missingScopes) && r.missingScopes.every((s): s is string => typeof s === "string")
      ? { missingScopes: r.missingScopes }
      : {}),
  };
};
